// A filename has "multiple extensions" when an extension-like token (a dot
// followed by 2–5 letters, not part of a longer word) appears before the
// final extension — e.g. "report.pdf (SECURE) .pdf" or "report.pdf.pdf".
// Single-extension names and interior dots that aren't extensions
// (e.g. "report.v2.pdf") are left alone.
const MULTIPLE_EXTENSION_REGEX = /\.[a-zA-Z]{2,5}(?![a-zA-Z]).*\.[a-zA-Z]{2,5}$/;

// Characters illegal in filenames on common operating systems (Windows
// forbids these outright; "/" is a path separator everywhere). All other
// characters — including &, commas, #, accents, brackets — are allowed.
const FORBIDDEN_CHARS_REGEX = /[/\\:*?"<>|]/;

export const hasMultipleExtensions = (filename: string): boolean => MULTIPLE_EXTENSION_REGEX.test(filename);

export const hasForbiddenChars = (filename: string): boolean => FORBIDDEN_CHARS_REGEX.test(filename);
